import store from '../../../store';
export default function checkIfCanSeeQuestionnaire() {
  let exists = false;
  let scopes = store.getters.userScopes;
  exists = scopes.includes('questionnaire_list');
  return exists;
}
